import { render } from "./LaboratoryHorseTestFormView.vue?vue&type=template&id=e504dcac"
import script from "./LaboratoryHorseTestFormView.vue?vue&type=script&lang=js"
export * from "./LaboratoryHorseTestFormView.vue?vue&type=script&lang=js"

import "./LaboratoryHorseTestFormView.vue?vue&type=style&index=0&id=e504dcac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__